const APPLICATION_GLOBAL_CONFIG = {
  apiBase: (window as any).RUNTIME_CONFIG?.apiBase,
  apiTimeout: (window as any).RUNTIME_CONFIG?.apiTimeout ?? 10000,
};

export default APPLICATION_GLOBAL_CONFIG;
